export default __webpack_public_path__ + "static/media/active-blood-sugar.86836bd5.svg";